import React from "react";
import { Flex } from "../atom/Flex";

function BottomLine() {
  return (
    <Flex justify="center" height="22.464px" align="center">
      <Flex width="131px" height="5px" color="mainBlack" radius="100px" />
    </Flex>
  );
}

export default BottomLine;
